import React, { useState, useEffect } from 'react'
import './Setting.css';
import Dashboardmy from '../Dashboard-component/Dashboard';
import { useSelector } from 'react-redux';
import { getWithTokenAPI, postWithTokenAPI, putAPI, deleteAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { FaRegTrashCan } from "react-icons/fa6";
import { RiPencilLine } from "react-icons/ri";
import { Helmet } from 'react-helmet';
function Address() {
    const navigate = useNavigate();
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);
    const userid = useSelector((state) => state.auth?.auth?._id);
    const username = useSelector((state) => state.auth?.auth?.name);
    const [loading, setLoading] = useState(true);
    const [showNewAddressForm, setShowNewAddressForm] = useState(false);
    const [isGettingLocation, setIsGettingLocation] = useState(false);
    const [locationError, setLocationError] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [addressToDelete, setAddressToDelete] = useState(null);
    const [showEditForm, setShowEditForm] = useState(false);
    const [newAddress, setNewAddress] = useState({
        name: '',
        street: '',
        city: '',
        state: '',
        zip_code: '',
        country: '',
        lat: '',
        long: ''
    });

    useEffect(() => {
        if (!accessToken || !userid) {
            toast.error('Please login to view address');
            navigate('/login');
            return;
        }
        fetchAddresses();
    }, [accessToken, userid]);

    const fetchAddresses = async () => {
        try {
            setLoading(true);
            const response = await getWithTokenAPI(accessToken, `/address/find-all?user_id=${userid}`);
            if (response?.statusCode === 200 && response.data?.address) {
                setAddresses(response.data.address);
                if (response.data.address.length > 0) {
                    setSelectedAddress(response.data.address[0]);
                }
            } else {
                console.error('Invalid response format:', response);
                toast.error('Failed to fetch addresses: Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching addresses:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to fetch addresses. Please try again later');
            }
        } finally {
            setLoading(false);
        }
    };

    const getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation is not supported by your browser'));
                return;
            }

            setIsGettingLocation(true);
            setLocationError(null);

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setIsGettingLocation(false);
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    resolve({ lat, long });
                },
                (error) => {
                    setIsGettingLocation(false);
                    let errorMessage = 'Unable to retrieve your location';
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = 'Location permission denied. Please enable location services.';
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = 'Location information is unavailable.';
                            break;
                        case error.TIMEOUT:
                            errorMessage = 'Location request timed out.';
                            break;
                        default:
                            errorMessage = 'An unknown error occurred while getting location.';
                    }
                    setLocationError(errorMessage);
                    reject(error);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        });
    };

    const handleAddNewAddress = async (e) => {
        e.preventDefault();
        setSelectedAddress(null);

        if (!newAddress.name || !newAddress.street || !newAddress.city ||
            !newAddress.state || !newAddress.zip_code || !newAddress.country) {
            toast.error("Please fill in all required fields");
            return;
        }

        try {
            const payload = {
                name: newAddress.name,
                street: newAddress.street,
                city: newAddress.city,
                state: newAddress.state,
                zip_code: newAddress.zip_code,
                country: newAddress.country,
                user_id: userid
            };

            try {
                setIsGettingLocation(true);
                setLocationError(null);
                const location = await getCurrentLocation();
                payload.lat = location.lat.toString();
                payload.long = location.long.toString();
            } catch (error) {
                console.log('Location not available, proceeding without coordinates');
            }

            const response = await postWithTokenAPI(accessToken, '/address/create', payload);

            if (response?.statusCode === 200) {
                toast.success('New address added successfully!');
                setShowNewAddressForm(false);
                setNewAddress({
                    name: '',
                    street: '',
                    city: '',
                    state: '',
                    zip_code: '',
                    country: '',
                    lat: '',
                    long: ''
                });
                setTimeout(() => {
                    fetchAddresses();
                }, 2000);
            } else {
                const errorMessage = response?.message || response?.error?.message || 'Failed to add new address';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Error adding new address:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to add new address. Please try again.');
            }
        } finally {
            setIsGettingLocation(false);
        }
    };

    const handleUpdateAddress = async () => {
        if (!selectedAddress) return;

        try {
            const payload = {
                _id: selectedAddress._id,
                name: selectedAddress.name,
                user_id: userid,
                street: selectedAddress.street,
                city: selectedAddress.city,
                state: selectedAddress.state,
                zip_code: selectedAddress.zip_code,
                country: selectedAddress.country,
                lat: selectedAddress.lat,
                long: selectedAddress.long
            };

            const response = await putAPI(accessToken, '/address/update', payload);

            if (response?.statusCode === 200) {
                toast.success('Address updated successfully!');
                setShowEditForm(false);
                setTimeout(() => {
                    fetchAddresses();
                }, 2000);

            } else {
                const errorMessage = response?.message || response?.error?.message || 'Failed to update address';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Error updating address:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to update address. Please try again.');
            }
        }
    };

    const handleDeleteClick = (addressId, e) => {
        e.stopPropagation();
        setAddressToDelete(addressId);
        setShowDeleteConfirm(true);
    };

    const handleDeleteConfirm = async () => {
        if (!addressToDelete) return;

        try {
            const payload = {
                _id: addressToDelete
            };

            const response = await deleteAPI(accessToken, '/address/delete', payload);

            if (response?.statusCode === 200) {
                toast.success('Address deleted successfully!');
                // Remove the deleted address from the list
                setAddresses(prevAddresses => prevAddresses.filter(addr => addr._id !== addressToDelete));
                // If the deleted address was selected, clear the selection
                if (selectedAddress?._id === addressToDelete) {
                    setSelectedAddress(null);
                }
            } else {
                const errorMessage = response?.message || response?.error?.message || 'Failed to delete address';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Error deleting address:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to delete address. Please try again.');
            }
        } finally {
            setShowDeleteConfirm(false);
            setAddressToDelete(null);
        }
    };

    const handleDeleteCancel = () => {
        setShowDeleteConfirm(false);
        setAddressToDelete(null);
    };

    const handleAddressSelect = (address) => {
        if (selectedAddress?._id === address._id) {
            setShowEditForm(!showEditForm);
        } else {
            setSelectedAddress(address);
            setShowEditForm(true);
        }
        setShowNewAddressForm(false);
    };

    const handleAddressChange = (e) => {
        const { id, value } = e.target;
        setSelectedAddress(prev => ({
            ...prev,
            [id]: value
        }));
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <>
            <ToastContainer autoClose={3000} />

            <Helmet>
                <title>{`${username} | Address`}</title>
                <meta name="description" content={`user address page of Shambasync`} />
            </Helmet>
            <div className='show-content'>
                <Dashboardmy />
                <div className="billing-container-address">
                    {/* Delete Confirmation Popup */}
                    {showDeleteConfirm && (
                        <div className="delete-confirmation-overlay">
                            <div className="delete-confirmation-popup">
                                <h3>Delete Address</h3>
                                <p>Are you sure you want to delete this address?</p>
                                <div className="delete-confirmation-buttons">
                                    <button
                                        className="delete-confirm-btn"
                                        onClick={handleDeleteConfirm}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        className="delete-cancel-btn"
                                        onClick={handleDeleteCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="address-header">
                        <h2 className="billing-title">Billing Addresses</h2>
                        <button
                            className="toggle-form-btn"
                            onClick={() => {
                                setShowNewAddressForm(!showNewAddressForm);
                                if (showNewAddressForm) {
                                    setSelectedAddress(null);
                                    setShowEditForm(false);
                                }
                            }}
                        >
                            {showNewAddressForm ? 'Close' : 'Add New Address'}
                        </button>
                    </div>

                    {showNewAddressForm && (
                        <div className="billing-address-form">
                            <h3 className="section-title">Add New Address</h3>
                            <div className="input-block">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    value={newAddress.name}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, name: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="input-block full-width">
                                <label htmlFor="street">Street Address</label>
                                <input
                                    type="text"
                                    id="street"
                                    value={newAddress.street}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, street: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="city">City</label>
                                <input
                                    type="text"
                                    id="city"
                                    value={newAddress.city}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, city: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="state">State</label>
                                <input
                                    type="text"
                                    id="state"
                                    value={newAddress.state}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, state: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="zip_code">Zip Code</label>
                                <input
                                    type="text"
                                    id="zip_code"
                                    value={newAddress.zip_code}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, zip_code: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="country">Country</label>
                                <input
                                    type="text"
                                    id="country"
                                    value={newAddress.country}
                                    onChange={(e) => setNewAddress(prev => ({ ...prev, country: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="location-status">
                                {isGettingLocation && (
                                    <div className="location-loading">
                                        Getting your location...
                                    </div>
                                )}
                                {locationError && (
                                    <div className="location-error">
                                        {locationError}
                                    </div>
                                )}
                            </div>

                            <button
                                type="button"
                                className="billing-save-button-checkout"
                                onClick={handleAddNewAddress}
                                disabled={isGettingLocation}
                            >
                                {isGettingLocation ? 'Getting Location...' : 'Save Address'}
                            </button>
                        </div>
                    )}

                    <div className="address-selection-form">
                        <h2 className="section-title">Your Addresses</h2>
                        {loading ? (
                            <div className="loading-message">Loading addresses...</div>
                        ) : addresses.length === 0 ? (
                            <div className="no-addresses-message">No saved addresses found</div>
                        ) : (
                            <div className="address-list">
                                {addresses.map((address) => (
                                    <div
                                        key={address._id}
                                        className={`address-item ${selectedAddress?._id === address._id ? 'selected' : ''}`}
                                        onClick={() => handleAddressSelect(address)}
                                    >
                                        <input
                                            type="radio"
                                            name="address"
                                            value={address._id}
                                            checked={selectedAddress?._id === address._id}
                                            onChange={() => handleAddressSelect(address)}
                                            className="address-radio"
                                        />
                                        <div className="address-details">
                                            <div className="address-name">{address.name}</div>
                                            <div className="address-street">{address.street}</div>
                                            <div className="address-city-state">
                                                {address.city}, {address.state} {address.zip_code}
                                            </div>
                                            <div className="address-country">{address.country}</div>
                                        </div>
                                        <button
                                            className="edit-address-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedAddress(address);
                                                setShowEditForm(true);
                                            }}
                                        >
                                            <RiPencilLine className='pencil' />
                                        </button>
                                        <button
                                            className="delete-address-btn"
                                            onClick={(e) => handleDeleteClick(address._id, e)}
                                        >
                                            <FaRegTrashCan className='delete-icon' />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {selectedAddress && !showNewAddressForm && showEditForm && (
                        <div className="billing-address-form">
                            <h3 className="section-title">Edit Address</h3>
                            <div className="input-block">
                                <label htmlFor="name">Address Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    value={selectedAddress.name}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <div className="input-block full-width">
                                <label htmlFor="street">Street Address</label>
                                <input
                                    type="text"
                                    id="street"
                                    value={selectedAddress.street}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="city">City</label>
                                <input
                                    type="text"
                                    id="city"
                                    value={selectedAddress.city}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="state">State</label>
                                <input
                                    type="text"
                                    id="state"
                                    value={selectedAddress.state}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="zip_code">Zip Code</label>
                                <input
                                    type="text"
                                    id="zip_code"
                                    value={selectedAddress.zip_code}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <div className="input-block">
                                <label htmlFor="country">Country</label>
                                <input
                                    type="text"
                                    id="country"
                                    value={selectedAddress.country}
                                    onChange={handleAddressChange}
                                />
                            </div>

                            <button
                                className="billing-save-button-checkout"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleUpdateAddress();
                                }}
                            >
                                Update Address
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Address;